module.exports = __webpack_public_path__ + "img/Medusa_avatar_bg.fa0abf8d.png";